import type { ReactNode } from 'react'

import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import type { SearchModalItemKind } from '../../search-modal.type'
import { SearchRowIcon } from '../SearchRowIcon'

import styles from '../../SearchModal.module.scss'

type SearchRowIconCellProps = {
  rowIconKind: string
  icon?: ReactNode
  kind?: SearchModalItemKind
}

export function SearchRowIconCell({ rowIconKind, icon, kind }: SearchRowIconCellProps) {
  return (
    <span className={styles.iconCell} data-testid={SEARCH_MODAL_TEST_IDS.rowIconCell} data-row-icon-cell={rowIconKind}>
      {icon ?? <SearchRowIcon kind={kind} />}
    </span>
  )
}
